import React, { useEffect, useState } from "react";
import constant from "../../../helper/constant";
import { getAnalyticsDashboardURL, getCustomDashboardURL } from "../../../service/ai-model.service";
import CustomLoader from "../../common/CustomLoader";
import { useAppContext } from "../../../context/app.context";

const CustomDashboardView = () => {
  const [url, setURL] = useState("");
  const [loading, setLoading] = useState(true);
  const { updateLeftMenu } = useAppContext();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const viewId = params.get("viewId");
    const workspaceId = params.get("workspaceId");
    updateLeftMenu(false);
    getCustomDashboardURL({ workspaceId, viewId })
      .then((link) => setURL(link))
      .catch(() => setURL(null))
      .finally(() => setLoading(false));
  }, []);

  const render = () => {
    if (loading) {
      return (
        <p className="ai-inference-frame d-flex align-items-center justify-content-center">
          <CustomLoader />
        </p>
      );
    }
    if (url) {
      const params = new URLSearchParams(window.location.search);
      const org = params.get("org");
      return (
        <div className="d-flex flex-column gap-2 p-5">
          <h3>Visualize - {org}</h3>
          <small className="mb-1">**Please use Credentials from dashboard screen</small>
          <iframe
            src={url}
            onError={(e) => console.log(e)}
            className="ai-inference-frame"
            allowFullScreen
          />
        </div>
      );
    }
    return (
      <p className="error-msg text-center p-5">
        {constant.MESSAGES.COMMON_ERROR_MESSAGE}
      </p>
    );
  };

  return render();
};

export default CustomDashboardView;
